import React from 'react';
import { DEFAULT_FILTER_BY, FILTER_BY_OPTIONS } from '../Filters';
import { DateRange } from '../../../../components/DateRangePicker';
import moment from 'moment';
import { getArrayQueryParam, getQueryParam } from '../../../../utils/url';
import { SelectOption } from '../../../../components/Select';
import { PipelinePerformanceBody } from '../PipelinePerformanceBody';

function stringArrayToSelectOptions(strs: string[]): SelectOption[] {
  return strs.map((id) => ({
    label: '',
    value: id,
  }));
}

export default function PipelinePerformancePdfExportBody() {
  const filterBy =
    FILTER_BY_OPTIONS.find((v) => v['value'] == getQueryParam('filter_by')) ??
    DEFAULT_FILTER_BY;

  const filterState = {
    filterBy: filterBy,
    entries: stringArrayToSelectOptions(getArrayQueryParam('filter_by_ids[]')),
    dateRange: {
      start: moment(getQueryParam('start_date')),
      end: moment(getQueryParam('end_date')),
      range: DateRange.CustomRange,
    },
    locations: stringArrayToSelectOptions(getArrayQueryParam('location_ids[]')),
    stageIds: stringArrayToSelectOptions(getArrayQueryParam('stage_ids[]')),
  };

  const heatmapGroupBy = getQueryParam('heatmap_group_by') ?? 'department';
  const rejectionGroupBy = getQueryParam('rejection_group_by') ?? 'department';

  return (
    <PipelinePerformanceBody
      filterState={filterState}
      heatmapGroupBy={heatmapGroupBy}
      onHeatmapGroupByChange={() => {}}
      rejectionGroupBy={rejectionGroupBy}
      onRejectionGroupByChange={() => {}}
    />
  );
}
